export const notifyText = {
  en: {
    when: 'Send it at', tz: 'Pacific time', evening: 'Evening nudge at 9pm if the reading is not finished.',
    email: 'Daily reading email', langs: 'Send the reading in',
    push: 'Notify me on this device',
    note: 'Spanish sends the passages only — the devotional has no Spanish edition yet.',
    keepOne: 'Keep at least one language selected.',
    max: 'Two languages at most — a longer email gets cut short by Gmail.',
    blocked: 'Notifications are blocked for this site. Turn them back on in your browser settings.',
    iosTitle: 'To get notifications on iPhone or iPad',
    iosSteps: 'Tap Share, then “Add to Home Screen”, and open the app from that icon. Apple only allows notifications for installed sites.',
    macTitle: 'On a Mac',
    macSteps: 'Safari needs the site added to the Dock, or use Chrome, where notifications work from a normal tab.',
    logout: 'Log out',
  },
  es: {
    when: 'Enviar a las', tz: 'hora del Pacífico', evening: 'Aviso a las 9pm si la lectura no está terminada.',
    email: 'Correo de lectura diaria', langs: 'Enviar la lectura en',
    push: 'Avisarme en este dispositivo',
    note: 'En español se envían solo los pasajes; el devocional aún no existe en español.',
    keepOne: 'Mantén al menos un idioma seleccionado.',
    max: 'Máximo dos idiomas — Gmail recorta los correos más largos.',
    blocked: 'Las notificaciones están bloqueadas para este sitio. Actívalas en la configuración del navegador.',
    iosTitle: 'Para recibir avisos en iPhone o iPad',
    iosSteps: 'Toca Compartir, luego «Añadir a pantalla de inicio», y abre la app desde ese icono. Apple solo permite notificaciones en sitios instalados.',
    macTitle: 'En Mac',
    macSteps: 'Safari necesita el sitio añadido al Dock, o usa Chrome, donde los avisos funcionan desde una pestaña normal.',
    logout: 'Cerrar sesión',
  },
  zh: {
    when: '發送時間', tz: '太平洋時間', evening: '晚上九點若尚未讀完會再提醒一次。',
    email: '每日讀經郵件', langs: '郵件語言',
    push: '在這個裝置上通知我',
    note: '西班牙文只寄經文，靈修內容尚無西班牙文版本。',
    keepOne: '請至少保留一種語言。',
    max: '最多兩種語言，過長的郵件會被 Gmail 截斷。',
    blocked: '此網站的通知已被封鎖，請到瀏覽器設定重新開啟。',
    iosTitle: 'iPhone 或 iPad 要接收通知',
    iosSteps: '請點分享，選「加入主畫面」，再從該圖示開啟。蘋果只允許已安裝的網站發送通知。',
    macTitle: 'Mac 使用者',
    macSteps: 'Safari 需將網站加入 Dock，或改用 Chrome，一般分頁即可接收通知。',
    logout: '登出',
  },
  sc: {
    when: '发送时间', tz: '太平洋时间', evening: '晚上九点若尚未读完会再提醒一次。',
    email: '每日读经邮件', langs: '邮件语言',
    push: '在这个设备上通知我',
    note: '西班牙文只寄经文，灵修内容尚无西班牙文版本。',
    keepOne: '请至少保留一种语言。',
    max: '最多两种语言，过长的邮件会被 Gmail 截断。',
    blocked: '此网站的通知已被阻止，请到浏览器设置重新开启。',
    iosTitle: 'iPhone 或 iPad 要接收通知',
    iosSteps: '请点分享，选「添加到主屏幕」，再从该图标打开。苹果只允许已安装的网站发送通知。',
    macTitle: 'Mac 用户',
    macSteps: 'Safari 需将网站加入程序坞，或改用 Chrome，普通标签页即可接收通知。',
    logout: '登出',
  },
};
